import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  loading: false,
  meterLoading: false,
  rainWaterList: [],
  purchaseList: [],
  groundWaterList: [],
  muncipalwaterlist: [],
  sourceEntryData: [],
};

export default function purchaseReducer(state = initialState, action) {
  switch (action.type) {
    //WATER TANKER------------------
    case actionTypes.FETCH_PURCHASE_INIT_ACTION:
      return {
        ...state,
        purchaseList: [],
        loading: true,
      };
    case actionTypes.FETCH_PURCHASE_SUCCESS_ACTION:
      return {
        ...state,
        purchaseList: action.payload.response_data,
        loading: false,
      };
    case actionTypes.FETCH_PURCHASE_FAIL_ACTION:
      return {
        ...state,
        purchaseList: [],
        loading: false,
      };
    case actionTypes.UPDATE_WATERTANKER_SUCCESS_ACTION:
      return {
        ...state,
        purchaseList: state.purchaseList.map((item) =>
          item.pid == action.payload.response_data[0].pid
            ? action.payload.response_data[0]
            : item,
        ),
      };
    case actionTypes.DELETE_WATERTANKER_SUCCESS_ACTION:
      return {
        ...state,
        purchaseList: state.purchaseList.filter(
          (item) => item.pid !== action.payload.pid,
        ),
      };
    // MUNCIPAL WATER---------------
    case actionTypes.FETCH_MUNCIPAL_WATER_INIT_ACTION:
      return {
        ...state,
        muncipalwaterlist: [],
        municipaloading: true,
      };
    case actionTypes.FETCH_MUNCIPAL_WATER_SUCCESS_ACTION:
      return {
        ...state,
        muncipalwaterlist: action.payload.response_data,
        municipaloading: false,
      };
    case actionTypes.FETCH_MUNCIPAL_WATER_FAIL_ACTION:
      return {
        ...state,
        muncipalwaterlist: [],
        municipaloading: false,
      };
    case actionTypes.UPDATE_MUNCIPAL_WATER_SUCCESS_ACTION:
      return {
        ...state,
        muncipalwaterlist: state.muncipalwaterlist.map((item) =>
          item.pid == action.payload.response_data[0].pid
            ? action.payload.response_data[0]
            : item,
        ),
      };
    case actionTypes.DELETE_MUNCIPAL_WATER_SUCCESS_ACTION:
      return {
        ...state,
        muncipalwaterlist: state.muncipalwaterlist.filter(
          (item) => item.pid !== action.payload.pid,
        ),
      };
    // RAIN WATER -------------------
    case actionTypes.FETCH_RAIN_WATER_PURCHASE_INIT_ACTION:
      return {
        ...state,
        rainWaterList: [],
        rainloading: true,
      };
    case actionTypes.FETCH_RAIN_WATER_PURCHASE_SUCCESS_ACTION:
      return {
        ...state,
        rainWaterList: action.payload.response_data,
        rainloading: false,
      };
    case actionTypes.FETCH_RAIN_WATER_PURCHASE_FAIL_ACTION:
      return {
        ...state,
        rainWaterList: [],
        rainloading: false,
      };
    case actionTypes.UPDATE_RAIN_WATER_PURCHASE_SUCCESS_ACTION:
      return {
        ...state,
        rainWaterList: state.rainWaterList.map((item) =>
          item.pid == action.payload.response_data[0].pid
            ? action.payload.response_data[0]
            : item,
        ),
      };
    case actionTypes.DELETE_RAIN_WATER_PURCHASE_SUCCESS_ACTION:
      return {
        ...state,
        rainWaterList: state.rainWaterList.filter(
          (item) => item.pid !== action.payload.pid,
        ),
      };
    // GROUND WATER -------------------
    case actionTypes.FETCH_GROUND_WATER_PURCHASE_INIT_ACTION:
      return {
        ...state,
        groundWaterList: [],
        groundloading: true,
      };
    case actionTypes.FETCH_GROUND_WATER_PURCHASE_SUCCESS_ACTION:
      return {
        ...state,
        groundWaterList: action.payload.response_data,
        groundloading: false,
      };
    case actionTypes.FETCH_GROUND_WATER_PURCHASE_FAIL_ACTION:
      return {
        ...state,
        groundWaterList: [],
        groundloading: false,
      };
    case actionTypes.UPDATE_GROUND_WATER_PURCHASE_SUCCESS_ACTION:
      return {
        ...state,
        groundWaterList: state.groundWaterList.map((item) =>
          item.pid == action.payload.response_data[0].pid
            ? action.payload.response_data[0]
            : item,
        ),
      };
    case actionTypes.DELETE_GROUND_WATER_PURCHASE_SUCCESS_ACTION:
      return {
        ...state,
        groundWaterList: state.groundWaterList.filter(
          (item) => item.pid !== action.payload.pid,
        ),
      };

    case actionTypes.FETCH_PURCHASE_DATA_INIT_ACTION:
      return {
        ...state,
        purchaseList: [],
        loading: true,
      };
    case actionTypes.FETCH_PURCHASE_DATA_SUCCESS_ACTION:
      return {
        ...state,
        purchaseList: action.payload?.data,
        loading: false,
      };
    case actionTypes.FETCH_PURCHASE_DATA_FAIL_ACTION:
      return {
        ...state,
        purchaseList: [],
        loading: false,
      };
    case actionTypes.FETCH_DATE_METER_READING_INIT_ACTION:
      return {
        ...state,
        // startTimeList: [],
        // endTimeList: [],
        meterReadingList: [],
        meterLoading: true,
      };
    case actionTypes.FETCH_DATE_METER_READING_SUCCESS_ACTION:
      // const convertEpochArray = (arr) => {
      //   return arr.map((item) => {
      //     const [epoch, reading] = item.split(":");

      //     const time = new Date(Number(epoch) * 1000).toLocaleTimeString(
      //       "en-GB",
      //       {
      //         timeZone: "UTC",
      //         hour: "2-digit",
      //         minute: "2-digit",
      //       }
      //     );

      //     return {
      //       time,
      //       meterReading: Number(reading) / 1000,
      //     };
      //   });
      // };
      const convertEpochPairs = (starts = [], ends = []) => {
        return starts?.map((startItem, index) => {
          const [startEpoch, startReading] = startItem.split(":");
          const [endEpoch, endReading] = ends[index]?.split(":") || [];

          // const formatTime = (epoch) =>
          //   epoch
          //     ? new Date(Number(epoch) * 1000).toLocaleTimeString("en-GB", {
          //         timeZone: "UTC",
          //         hour: "2-digit",
          //         minute: "2-digit",
          //       })
          //     : null;
          const formatTime = (epoch) => {
            if (!epoch) return null;
            return new Date(Number(epoch) * 1000)
              .toLocaleString("en-GB", {
                timeZone: "UTC",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })
              .replace(",", "");
          };

          const openingReading = startReading ? Number(startReading) / 1000 : 0;
          const closingReading = endReading ? Number(endReading) / 1000 : 0;

          return {
            startTime: formatTime(startEpoch),
            endTime: formatTime(endEpoch),
            opening: openingReading,
            closing: closingReading,
            vendor: "",
            capacity: "",
            rate: "",
            qty: (closingReading - openingReading)?.toFixed(2) || "",
            totalAmount: "",
            isChecked: false,
          };
        });
      };

      return {
        ...state,
        meterLoading: false,
        // startTimeList: convertEpochArray(action.payload.starts),
        // endTimeList: convertEpochArray(action.payload.ends),
        meterReadingList:
          action.payload &&
          action.payload.starts?.length &&
          action.payload.ends?.length
            ? convertEpochPairs(action.payload.starts, action.payload.ends)
            : [],
      };
    case actionTypes.FETCH_DATE_METER_READING_FAIL_ACTION:
      return {
        ...state,
        // startTimeList: [],
        // endTimeList: [],
        meterReadingList: [],
        meterLoading: false,
      };

    case actionTypes.GET_SOURCE_ENTRY_DATA_INIT_ACTION:
      return {
        ...state,
        loading: true,
        sourceEntryData: [],
      };
    case actionTypes.GET_SOURCE_ENTRY_DATA_SUCCESS_ACTION:
      return {
        ...state,
        loading: false,
        sourceEntryData: action.payload.data || [],
      };
    case actionTypes.GET_SOURCE_ENTRY_DATA_FAIL_ACTION:
      return {
        ...state,
        loading: false,
        sourceEntryData: [],
      };

    case actionTypes.CLEAR_WATER_PURCHASE_DATA:
      return {
        ...state,
        meterReadingList: [],
      };

    default:
      return {
        ...state,
      };
  }
}
